/* eslint-disable prefer-template */
/* eslint-disable react/prop-types */
import React from 'react';

const ResponsiveTable = ({
  columns,
  data,
  loading,
  onActionClick,
  emptyStateComponent,
  comingfrom
}) => {
  const cleanText = (val = "") =>
    String(val)
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();

  const truncate = (text, len = 30) =>
    text.length > len ? text?.slice(0, len) + "..." : text;

  if (loading) {
    return (
      <div id="table-loading-spinner" className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600" />
      </div>
    );
  }

  if (!data || data.length === 0) {

    if (typeof emptyStateComponent === 'function') {
      return emptyStateComponent();
    }

    if (emptyStateComponent) {
      return emptyStateComponent;
    }

    return (
      <div id="table-empty-state" className="text-center py-20">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 01-.707.293h-3.172a1 1 01-.707-.293l-2.414-2.414A1 1 006.586 13H4"
          />
        </svg>
        <p className="mt-4 text-gray-500 text-sm">{comingfrom === "ChapterQuestion" ? "No questions in this chapters yet" : "No data found"}</p>
      </div>
    );
  }

  return (
    <>

      <div id="table-mobile-view" className="lg:hidden space-y-4">
        {data.map((row, rowIndex) => (
          <div
            key={rowIndex}
            id={`table-row-mobile-${rowIndex}`}
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow duration-200"
          >
            {columns.map((column, colIndex) => {
              if (column.hidden) return null;

              const value = column.accessor
                ? column.accessor(row)
                : row[column.key];

              return (
                <div key={colIndex} className={`${colIndex !== 0 ? 'mt-3' : ''}`}>
                  <div className="flex justify-between items-start gap-3">
                    <span className="text-xs font-semibold text-gray-500 tracking-wider min-w-[80px]">
                      {column.label}
                    </span>
                    <div className="flex-1 text-right">
                      {column.render ? (
                        column.render(row, rowIndex, onActionClick)
                      ) : (
                        (() => {
                          const full = cleanText(value || "");
                          const short = truncate(full, 30);

                          return (
                            <div
                              className="text-sm text-gray-900 max-w-[250px] truncate"
                              title={full}
                            >
                              {short}
                            </div>
                          );
                        })()
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>


      <div id="table-desktop-view" className="hidden lg:block overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead id="table-head" className="bg-gray-50">
            <tr>
              {columns.map(
                (column, index) =>
                  !column.hidden && (
                    <th
                      key={index}
                      className={`px-6 py-3 text-xs font-semibold text-gray-600 tracking-wider ${column.headerClassName || ''
                        } ${column.centered ? 'text-center' : 'text-left'}`}
                    >
                      {column.label}
                    </th>
                  )
              )}
            </tr>
          </thead>

          <tbody id="table-body" className="bg-white divide-y divide-gray-200">
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                id={`table-row-${rowIndex}`}
                className="hover:bg-gray-50 transition-colors duration-150"
              >
                {columns.map((column, colIndex) => {
                  if (column.hidden) return null;

                  const value = column.accessor
                    ? column.accessor(row)
                    : row[column.key];

                  return (
                    <td
                      key={colIndex}
                      id={`table-cell-${rowIndex}-${colIndex}`}
                      className={`px-6 py-4 whitespace-nowrap ${column.cellClassName || ''
                        } ${column.centered ? 'text-center' : 'text-left'}`}
                    >
                      {column.render ? (
                        column.render(row, rowIndex, onActionClick)
                      ) : (
                        // <span className="text-sm text-gray-900">{value}</span>
                        (() => {
                          const full = cleanText(value || "");
                          const short = truncate(full, 30);

                          return (
                            <div
                              className="text-sm text-gray-900 max-w-[250px] truncate"
                              title={full}
                            >
                              {short}
                            </div>
                          );
                        })()
                      )}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ResponsiveTable;